import React from 'react';
import combineAllErrors from '../lib/combineAllErrors';

/**
 * Label to display general API errors.
 */
const Error = ({ message }) => {
  if (message instanceof Object) {
    message = combineAllErrors(message);
  }

  return message ? (
    <div className="u-color-mahogany u-bg-color-solitude u-margin-bottom-small">
      <div className="u-text-center u-font-size--medium u-text-display-space">
        {message}
      </div>
    </div>
  ) : null;
};

export default Error;
